import {BrowserModule} from "@angular/platform-browser";
import {ErrorHandler, NgModule} from "@angular/core";
import {IonicApp, IonicErrorHandler, IonicModule} from "ionic-angular";
import {SplashScreen} from "@ionic-native/splash-screen";
import {StatusBar} from "@ionic-native/status-bar";

import {MyApp} from "./app.component";
import {HomePageModule} from "../pages/home/home.module";
import {LoginPageModule} from "../pages/login/login.module";
import {ForgotPageModule} from "../pages/forgot/forgot.module";
import {ForgotResetPageModule} from "../pages/forgot-reset/forgot-reset.module";
import {FingerBoardPageModule} from "../pages/finger-board/finger-board.module";
import {FingerBasicPageModule} from "../pages/finger-basic/finger-basic.module";
import {FingerBigFriendMinusPageModule} from "../pages/finger-big-friend-minus/finger-big-friend-minus.module";
import {FingerBigFriendPlusPageModule} from "../pages/finger-big-friend-plus/finger-big-friend-plus.module";
import {FingerFlashCardPageModule} from "../pages/finger-flash-card/finger-flash-card.module";
import {FingerLittleFriendMinusPageModule} from "../pages/finger-little-friend-minus/finger-little-friend-minus.module";
import {FingerLittleFriendPlusPageModule} from "../pages/finger-little-friend-plus/finger-little-friend-plus.module";
import {FingerPlusMinusPageModule} from "../pages/finger-plus-minus/finger-plus-minus.module";
import {SorobanBasicBasicPageModule} from "../pages/soroban-basic-basic/soroban-basic-basic.module";
import {SorobanBasicBigFriendMinusPageModule} from "../pages/soroban-basic-big-friend-minus/soroban-basic-big-friend-minus.module";
import {SorobanBasicBigFriendPlusPageModule} from "../pages/soroban-basic-big-friend-plus/soroban-basic-big-friend-plus.module";
import {SorobanBasicBoardPageModule} from "../pages/soroban-basic-board/soroban-basic-board.module";
import {SorobanBasicFlashCardPageModule} from "../pages/soroban-basic-flash-card/soroban-basic-flash-card.module";
import {SorobanBasicLittleFriendMinusPageModule} from "../pages/soroban-basic-little-friend-minus/soroban-basic-little-friend-minus.module";
import {SorobanBasicLittleFriendPlusPageModule} from "../pages/soroban-basic-little-friend-plus/soroban-basic-little-friend-plus.module";
import {SorobanBasicPlusMinusPageModule} from "../pages/soroban-basic-plus-minus/soroban-basic-plus-minus.module";
import {SorobanBoardPageModule} from "../pages/soroban-board/soroban-board.module";
import {SorobanAddSubBoardPageModule} from "../pages/soroban-add-sub-board/soroban-add-sub-board.module";
import {SorobanAddSubAddSubPageModule} from "../pages/soroban-add-sub-add-sub/soroban-add-sub-add-sub.module";
import {SorobanAddSubAddSubSoAmPageModule} from "../pages/soroban-add-sub-add-sub-so-am/soroban-add-sub-add-sub-so-am.module";
import {SorobanAddSubAddSubSoThapPhanPageModule} from "../pages/soroban-add-sub-add-sub-so-thap-phan/soroban-add-sub-add-sub-so-thap-phan.module";
import {HttpClientModule, HTTP_INTERCEPTORS, HttpClient} from "@angular/common/http";
import {FisoMathProvider} from "../providers/fiso-math/fiso-math";
import {SorobanDivisonBoardPageModule} from "../pages/soroban-divison-board/soroban-divison-board.module";
import {SorobanDivisonOnePageModule} from "../pages/soroban-divison-one/soroban-divison-one.module";
import {SorobanDivisonTwoPageModule} from "../pages/soroban-divison-two/soroban-divison-two.module";
import {SorobanMultiBoardPageModule} from "../pages/soroban-multi-board/soroban-multi-board.module";
import {SorobanMultiOnePageModule} from "../pages/soroban-multi-one/soroban-multi-one.module";
import {SorobanMultiTwoPageModule} from "../pages/soroban-multi-two/soroban-multi-two.module";
import {ProfilePageModule} from "../pages/profile/profile.module";
import {AccountProvider} from "../providers/account/account";
import {HeaderInterceptor} from "./HttpInterceptor";
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {FightPageModule} from "../pages/fight/fight.module";
import {FightFormPageModule} from "../pages/fight-form/fight-form.module";
import {RoomProvider} from '../providers/room/room';
import {TrainingPageModule} from "../pages/training/training.module";
import {SorobanBasicLittleFriendMixPageModule} from "../pages/soroban-basic-little-friend-mix/soroban-basic-little-friend-mix.module";
import {SorobanBasicBigFriendMixPageModule} from "../pages/soroban-basic-big-friend-mix/soroban-basic-big-friend-mix.module";
import {FingerBigFriendMixPageModule} from "../pages/finger-big-friend-mix/finger-big-friend-mix.module";
import {FingerLittleFriendMixPageModule} from "../pages/finger-little-friend-mix/finger-little-friend-mix.module";
import {SorobanMultiFivePageModule} from "../pages/soroban-multi-five/soroban-multi-five.module";
import {SorobanMultiFourPageModule} from "../pages/soroban-multi-four/soroban-multi-four.module";
import {SorobanMultiSixPageModule} from "../pages/soroban-multi-six/soroban-multi-six.module";
import {SorobanMultiThreePageModule} from "../pages/soroban-multi-three/soroban-multi-three.module";
import {SorobanDivisonThreePageModule} from "../pages/soroban-divison-three/soroban-divison-three.module";
import {CommonProvider} from '../providers/common/common';
import {SorobanExamPageModule} from "../pages/soroban-exam/soroban-exam.module";
import {FingerExamPageModule} from "../pages/finger-exam/finger-exam.module";
import {DemoPageModule} from "../pages/demo/demo.module";
import {RegisterPageModule} from "../pages/register/register.module";
import {VideoDetailPageModule} from "../pages/video-detail/video-detail.module";
import {VideoShopPageModule} from "../pages/video-shop/video-shop.module";
import {VideoListPageModule} from "../pages/video-list/video-list.module";

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
    declarations: [MyApp],
    imports: [
        BrowserModule,
        HttpClientModule,

        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),

        HomePageModule,
        LoginPageModule,
        ForgotPageModule,
        ForgotResetPageModule,
        FingerBoardPageModule,
        FingerBasicPageModule,
        FingerBigFriendMinusPageModule,
        FingerBigFriendPlusPageModule,
        FingerFlashCardPageModule,
        FingerLittleFriendMinusPageModule,
        FingerLittleFriendPlusPageModule,
        FingerPlusMinusPageModule,
        SorobanBasicBasicPageModule,
        SorobanBasicBigFriendMinusPageModule,
        SorobanBasicBigFriendPlusPageModule,
        SorobanBasicBoardPageModule,
        SorobanBasicFlashCardPageModule,
        SorobanBasicLittleFriendMinusPageModule,
        SorobanBasicLittleFriendPlusPageModule,
        SorobanBasicPlusMinusPageModule,
        SorobanBoardPageModule,
        SorobanAddSubBoardPageModule,
        SorobanAddSubAddSubPageModule,
        SorobanAddSubAddSubSoAmPageModule,
        SorobanAddSubAddSubSoThapPhanPageModule,
        SorobanDivisonBoardPageModule,
        SorobanDivisonOnePageModule,
        SorobanDivisonTwoPageModule,
        SorobanMultiBoardPageModule,
        SorobanMultiOnePageModule,
        SorobanMultiTwoPageModule,
        ProfilePageModule,
        FightPageModule,
        FightFormPageModule,
        TrainingPageModule,
        SorobanBasicLittleFriendMixPageModule,
        SorobanBasicBigFriendMixPageModule,
        FingerBigFriendMixPageModule,
        FingerLittleFriendMixPageModule,
        SorobanMultiFivePageModule,
        SorobanMultiFourPageModule,
        SorobanMultiSixPageModule,
        SorobanMultiThreePageModule,
        SorobanDivisonThreePageModule,
        SorobanExamPageModule,
        FingerExamPageModule,
        DemoPageModule,
        RegisterPageModule,
        VideoDetailPageModule,
        VideoShopPageModule,
        VideoListPageModule,
        IonicModule.forRoot(MyApp, {
            scrollPadding: false,
            scrollAssist: false,
            autoFocusAssist: false,
            // mode: "ios",
            backButtonText: "Quay lại",
            // modalEnter: 'modal-slide-in',
            // modalLeave: 'modal-slide-out',
            // tabsPlacement: 'bottom',
            // pageTransition: 'md-transition',
        })
    ],
    bootstrap: [IonicApp],
    entryComponents: [MyApp],
    providers: [
        StatusBar,
        SplashScreen,
        {provide: ErrorHandler, useClass: IonicErrorHandler},
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HeaderInterceptor,
            multi: true
        },
        FisoMathProvider,
        AccountProvider,
        TranslateService,
        RoomProvider,
        CommonProvider
    ]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts